<div class="info-header row space-between">
  <span class="col-11">CLOSING DEADLINES</span>
</div>
<div class="info-container">
  <div class="row align-top">
    <div class="col-md-9 col-lg-11 row align-top gutters">
      <div *ngTemplateOutlet="item; context: { tRow: row1 }"></div>
    </div>
  </div>
</div>
<ng-template #item let-tRow="tRow">
  @for (tData of tRow; track tData) {
    <div class="col-4">
      <b>{{ tData.key }}: </b>
      <span>{{ tData.value }}</span>
    </div>
  }
</ng-template>
